<template>
  <div class="client opportunity perks-editor">
    <v-btn icon @click="editing = !editing"> <v-icon>mdi-pencil</v-icon> </v-btn>
    <v-dialog scrollable v-model="editing" max-width="900px" width="66vw" height="50">
      <v-card>
        <v-card-title class="title">Edit Perks</v-card-title>

        <v-divider />

        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-combobox
              multiple
              label="Add perks"
              v-model="opportunityPerks.perks"
              :items="[]"
              append-icon=""
              :loading="loading"
              :color="themes.client.light.input"
            >
              <v-chip
                slot="selection"
                slot-scope="data"
                @input="data.parent.selectItem(data.item)"
                :class="themes.client.light.chip"
                :selected="data.selected"
                :key="`key-perks-${data.item}`"
              >
                <v-icon left>mdi-check-decagram</v-icon>
                {{ data.item }}
                <v-icon right small @click="data.parent.selectItem(data.item)">mdi-close</v-icon>
              </v-chip>
            </v-combobox>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="editing = false" :color="themes.client.light.cancel"> Cancel </v-btn>
          <v-btn :color="themes.client.light.primaryActionButton" :disabled="!valid" @click="submit">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <!-- <v-dialog v-model="editing" max-width="600px" v-if="edit"> -->
  <!-- <v-btn flat icon  slot="activator" :color="themes.client.light.secondaryActionButton"> -->
  <!-- <v-icon>mdi-pencil</v-icon> -->
  <!-- </v-btn> -->
  <!-- <v-card> -->
  <!-- <v-card-title class="headline">Perks</v-card-title> -->
  <!-- <v-card-text> -->
  <!-- </v-card-text> -->
  <!-- <v-card-actions><v-spacer /> -->
  <!-- <v-btn flat @click="cancel" :color="themes.client.light.cancel"> -->
  <!-- Cancel -->
  <!-- </v-btn> -->
  <!-- <v-btn :color="themes.client.light.primaryActionButton"  @click="submit"> -->
  <!-- Save -->
  <!-- </v-btn> -->
  <!-- </v-card-actions> -->
  <!-- </v-card> -->
  <!-- </v-dialog> -->
  <!-- </v-card-title> -->

  <!-- <v-divider /> -->

  <!-- <v-list dense v-if="opportunity.perks.length"> -->
  <!-- <v-list-tile v-for="perk in opportunity.perks" :key="`perk-${perk}`"> -->
  <!-- <v-list-tile-avatar><v-icon>mdi-check-decagram</v-icon></v-list-tile-avatar> -->
  <!-- <v-list-tile-content> -->
  <!-- {{ perk }} -->
  <!-- </v-list-tile-content> -->
  <!-- </v-list-tile> -->
  <!-- </v-list> -->
  <!-- <v-alert :value="!opportunity.perks.length" -->
  <!-- type="warning" :color="themes.client.light.warning" -->
  <!-- class="mt-0"> -->
  <!-- No perks have been added -->
  <!-- </v-alert> -->
  <!-- </v-card> -->
</template>

<script>
export default {
  props: {
    opportunity: Object,
    edit: Boolean,
  },
  data() {
    return {
      // Model
      opportunityPerks: {
        perks: this.opportunity.perks || [],
      },
      editing: false,
      loading: false,
      valid: false,
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.$store
        .dispatch(
          'client/opportunities/update',
          Object.assign({}, this.opportunity, this.opportunityPerks)
        )
        .then(
          response => {
            this.$store.dispatch('snackbarSuccess', 'The perks were updated successfully')
            this.editing = false
          },
          errors => {
            if (errors) {
              this.errors = errors
              this.$store.dispatch('snackbarError', 'There was a problem updating the perks')
            } else {
              this.$store.dispatch('snackbarSuccess', 'The perks were updated successfully')
              this.editing = false
            }
          }
        )
        .finally(() => (this.loading = false))
    },
    cancel() {
      this.editing = false
    },
  },
}
</script>
